var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEverifyLogoGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 165.76 60.48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#039447;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 92.22,
    y1: -4.49,
    x2: -3.22,
    y2: 65.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#039447"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.36,58.97l-9.48-36.39c-.47-1.8,2.01-2.79,2.91-1.16l9.66,16.53c.52.93,1.78,1.1,2.52.33L93.23.51c1.39-1.44,3.62.49,2.38,2.07l-58.48,56.97c-.81,1.03-2.44.69-2.77-.57Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.41,40.17l7.4,1.24c-.95,2.71-2.45,4.78-4.5,6.2-2.05,1.42-4.62,2.13-7.7,2.13-4.88,0-8.49-1.59-10.83-4.78-1.85-2.55-2.77-5.78-2.77-9.67,0-4.65,1.22-8.29,3.65-10.92,2.43-2.63,5.5-3.95,9.22-3.95,4.17,0,7.47,1.38,9.88,4.14,2.41,2.76,3.57,6.98,3.46,12.67H7.61c.05,2.2.65,3.91,1.8,5.14,1.14,1.22,2.57,1.84,4.28,1.84,1.16,0,2.14-.32,2.93-.95.79-.63,1.39-1.66,1.8-3.06Zm.42-7.5c-.05-2.15-.61-3.78-1.66-4.9-1.06-1.12-2.34-1.68-3.86-1.68-1.62,0-2.96.59-4.02,1.77-1.06,1.18-1.58,2.78-1.56,4.81h11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.89,35.28c0,3.89.93,7.12,2.77,9.67,2.34,3.19,5.95,4.78,10.83,4.78,3.08,0,5.65-.71,7.7-2.13,2.05-1.42,3.55-3.48,4.5-6.2l-7.4-1.24c-.41,1.41-1,2.43-1.8,3.06s-1.77.95-2.93.95c-1.71,0-3.14-.61-4.28-1.84-1.15-1.22-1.74-2.94-1.8-5.14h18.6c.11-5.69-1.05-9.91-3.46-12.67-1.97-2.25-4.54-3.57-7.68-3.98l-15.07,14.68s0,.03,0,.04Zm9.3-7.42c1.06-1.18,2.39-1.77,4.02-1.77,1.51,0,2.8.56,3.86,1.68s1.61,2.75,1.66,4.9h-11.1c-.02-2.03.5-3.63,1.56-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m98.44,49.1h-7.42v-28.06h6.9v3.99c1.18-1.88,2.24-3.13,3.18-3.72.94-.6,2.01-.9,3.21-.9,1.69,0,3.32.47,4.89,1.4l-2.3,6.47c-1.25-.81-2.41-1.21-3.49-1.21s-1.92.29-2.64.86c-.72.57-1.29,1.61-1.7,3.1s-.62,4.63-.62,9.4v8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.18,17.23v-6.87h7.42v6.87h-7.42Zm0,31.86v-28.06h7.42v28.06h-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m119.15,21.04h4.12v-2.11c0-2.36.25-4.12.75-5.28.5-1.16,1.43-2.11,2.77-2.84,1.35-.73,3.05-1.1,5.11-1.1s4.18.32,6.21.95l-1,5.18c-1.18-.28-2.32-.42-3.41-.42s-1.85.25-2.31.75c-.47.5-.7,1.47-.7,2.89v1.98h5.55v5.84h-5.55v22.22h-7.42v-22.22h-4.12v-5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m136.91,21.04h7.9l6.71,19.92,6.55-19.92h7.69l-9.91,27-1.77,4.89c-.65,1.64-1.27,2.89-1.86,3.75-.59.86-1.27,1.56-2.03,2.1-.77.54-1.71.96-2.83,1.25-1.12.3-2.38.45-3.79.45s-2.83-.15-4.2-.45l-.66-5.81c1.16.23,2.21.34,3.14.34,1.73,0,3-.51,3.83-1.52.83-1.01,1.46-2.3,1.9-3.87l-10.67-28.14Z"
  }))));
}
export default SvgEverifyLogoGradient;